import { useLogout } from '../api'

const icon = new URL('../assets/logout.png?width=128&height=128', import.meta.url).toString()

export const LogoutButton = () => {
    const logout = useLogout()
    return (
        <button
            onClick={() => logout.mutate()}
            className='h-9 w-9 flex flex-row items-center justify-center border rounded-full'
        >
            <img src={icon} alt='logout' className='w-3 h-3 object-contain' />
        </button>
    )
}

/**
 * Sign out as one full-width row, for the account dropdown.
 *
 * It used to be a `<span>` label sitting beside a 36px circular icon button, and only the icon did
 * anything — so the word "Sign out" was dead, and the target was a fraction of the row every other
 * entry in that menu offers. Now the whole row is the button, styled to match `PanelLink` so the
 * menu reads as one list.
 */
export const LogoutMenuItem = ({ onLogout }: { onLogout?: () => void }) => {
    const logout = useLogout()
    return (
        <button
            type='button'
            onClick={() => {
                logout.mutate()
                onLogout?.()
            }}
            className='flex w-full flex-row items-center justify-between gap-3 border-l-2 border-transparent px-4 py-3 text-left transition-colors hover:border-[#C91FFF] hover:bg-white/5'
        >
            <span className='text-sm font-bold uppercase tracking-wide text-white/50'>Sign out</span>
            <img src={icon} alt='' className='h-3 w-3 shrink-0 object-contain opacity-50' />
        </button>
    )
}

export const LogoutButtonMobile = () => {
    const logout = useLogout()
    return <button onClick={() => logout.mutate()}>LOGOUT</button>
}
